export enum RequisitionStatuses {
  OPEN = 1,
  AWAITING_APPROVAL_OF_PM_HOD,
  AWAITING_APPROVAL_OF_QS,
  AWAITING_APPROVAL_OF_TECHNICAL_ENGINEER,
  AWAITING_APPROVAL_OF_PROCUREMENT_MANAGER,
  UNDER_PROCESS_WITH_PURCHASE,
  COMPLETED,
  CANCELLED,
  AWAITING_APPROVAL_OF_PROJECT_DIRECTOR,
  AWAITING_APPROVAL_OF_CONSTRUCTION__MANAGER,
  AWAITING_APPROVAL_OF_PROJECT_MANAGER_SENIOR,
  AWAITING_APPROVAL_OF_WAREHOUSE_MANAGER,
  AWAITING_APPROVAL_OF_TECHNICAL_MANAGER,
  AWAITING_APPROVAL,
  AWAITING_APPROVAL_OF_COST_CONTROL_ENGINEER,
  AWAITING_APPROVAL_OF_TECHNICAL_REVIEW,
  AWAITING_APPROVAL_OF_SENIOR_STORE_KEEPER,
  AWAITING_APPROVAL_OF_PLANT_ENGINEER,
  AWAITING_APPROVAL_OF_PLANT_ACCOUNTANT,
  AWAITING_APPROVAL_OF_PLANT_WORK_SHOP_MANAGER,
  AWAITING_APPROVAL_OF_PLANT_MANAGER,
  AWAITING_APPROVAL_OF_HR_MANAGER,
  MR_CONSOLIDATED,
}
